import { ReactNode, useState, createContext } from 'react'
import Toast from '../Toast';

export type ToastState = {
    show: boolean;
    title: string;
}

const ToastInitialValues: ToastState = {
    show: false,
    title: ""
}

export type ToastContextType = {
    toast: ToastState;
    setToast: React.Dispatch<React.SetStateAction<ToastState>>;
}

const ToastContext = createContext<ToastContextType | null>(null);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [toast, setToast] = useState<ToastState>({ show: ToastInitialValues.show, title: ToastInitialValues.title });

    const value = { toast, setToast };

    return (
        <ToastContext.Provider value={value}>
            {children}
            <Toast />
        </ToastContext.Provider>
    )
}

export default ToastContext